export enum OrderCostSettlementMethod {
  Fiscal,
  NonFiscal
}
